// ─── Candidatos a graduación: quién ve la pestaña y el selector «cerca» (puro) ─
// El informe (resumen, distribución, lista y CSV) vive en candidates-report.model.

/** La pestaña existe solo con el expediente por credenciales, y solo para
 *  tenantAdmin (o platformAdmin) y registro. Sin él, /reports queda como siempre. */
export function showCandidatesTab(opts: {
  credentialRecord: boolean;
  isAdmin: boolean;
  isRegistrar: boolean;
}): boolean {
  return opts.credentialRecord && (opts.isAdmin || opts.isRegistrar);
}

/** Las opciones del selector «cerca» en pantalla (Adrian, 2026-10-26): 4 · 3 ·
 *  2 · 1 cursos, y el umbral del seminario si es mayor. Nunca más que el umbral
 *  con que calculó el servidor: quien está más lejos no vino en los datos. */
export function nearOptions(nearMax: number): number[] {
  const all = [nearMax, 4, 3, 2, 1].filter((n) => n >= 1 && n <= nearMax);
  return [...new Set(all)].sort((a, b) => b - a);
}
